import { ETravelStatus, Maybe, TravelType } from "@store/graphql/helpers/types.graphql";

/**
 * Travel statuses reached only after the delivery ticket is issued, i.e. concrete that already left the plant.
 */
const DELIVERED_STATUSES: string[] = [
  ETravelStatus.INVOICE_ISSUED,
  ETravelStatus.IN_TRANSIT,
  ETravelStatus.IN_CONSTRUCTION,
  ETravelStatus.DISCHARGING,
  ETravelStatus.DELIVERED
];

/**
 * Returns the delivered volume of a concreting. The value stored by the integration wins; when it was
 * never sent, the volume is summed from the travels that already left the plant, with the same rule the
 * integrations use.
 * @param deliveredVolume - Delivered volume stored for the concreting, null when it was not integrated.
 * @param travels - Travels of the concreting, with their status and volume.
 * @returns The delivered volume, zero when no travel left the plant yet.
 */
export const getDeliveredVolume = (
  deliveredVolume: Maybe<number> | undefined,
  travels: Maybe<Maybe<Pick<TravelType, "status" | "volume">>[]> | undefined
): number => {
  if (deliveredVolume !== null && deliveredVolume !== undefined) return Number(deliveredVolume);

  const total = (travels ?? []).reduce((sum, travel) => {
    if (!travel || !DELIVERED_STATUSES.includes(travel.status)) return sum;

    return sum + Number(travel.volume);
  }, 0);

  // Travel volumes carry two decimals; rounding keeps float noise out of the card.
  return Math.round(total * 100) / 100;
};
